import React from 'react';
import { Button } from 'wix-style-react';
import { getLoginLink } from '../utils';
export const SignInButton = ({ text, afterLoginLink }) => {
    const loginLink = getLoginLink(afterLoginLink);
    return (React.createElement(Button, { dataHook: "sign-in-button", priority: "secondary", as: "a", href: loginLink, size: "small" }, text));
};
//# sourceMappingURL=SignInButton.js.map